import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        score: 0,
        answers: 0,
        warnings: [
            {
                id: 1,
                name: 'warnings.test.1.name',
                orientation: 'rtl',
                color: 'creme',
                subject: 'warnings.test.1.subject',
                question: 'warnings.test.1.question',
                message: 'warnings.test.1.message',
                image: require('../assets/img/warnings-01.png'),
                answer: null,
                tooltips: {
                    a: 'warnings.test.1.tooltips.a',
                    b: 'warnings.test.1.tooltips.b'
                }
            },
            {
                id: 2,
                name: 'warnings.test.2.name',
                orientation: 'ltr',
                color: 'white',
                subject: 'warnings.test.2.subject',
                question: 'warnings.test.2.question',
                message: 'warnings.test.2.message',
                image: require('../assets/img/warnings-02.png'),
                answer: null,
                tooltips: {
                    a: 'warnings.test.2.tooltips.a'
                }
            },
            {
                id: 3,
                name: 'warnings.test.3.name',
                orientation: 'rtl',
                color: 'creme',
                subject: 'warnings.test.3.subject',
                question: 'warnings.test.3.question',
                message: 'warnings.test.3.message',
                image: require('../assets/img/warnings-03.png'),
                answer: null,
                tooltips: {
                    a: 'warnings.test.3.tooltips.a'
                }
            },
            {
                id: 4,
                name: 'warnings.test.4.name',
                orientation: 'ltr',
                color: 'white',
                subject: 'warnings.test.4.subject',
                question: 'warnings.test.4.question',
                message: 'warnings.test.4.message',
                image: require('../assets/img/warnings-04.png'),
                answer: null,
                tooltips: {
                    a: 'warnings.test.1.tooltips.a',
                    b: 'warnings.test.1.tooltips.b'
                }
            },
            {
                id: 5,
                name: 'warnings.test.5.name',
                orientation: 'ltr',
                color: 'creme',
                subject: 'warnings.test.5.subject',
                question: 'warnings.test.5.question',
                message: 'warnings.test.5.message',
                image: require('../assets/img/warnings-05.png'),
                answer: null,
                tooltips: {
                    a: 'warnings.test.5.tooltips.a'
                }
            },
            {
                id: 6,
                name: 'warnings.test.6.name',
                orientation: 'rtl',
                color: 'white',
                subject: 'warnings.test.6.subject',
                question: 'warnings.test.6.question',
                message: 'warnings.test.6.message',
                image: require('../assets/img/warnings-06.png'),
                answer: null,
                tooltips: {
                    a: 'warnings.test.6.tooltips.a',
                    b: 'warnings.test.6.tooltips.b'
                }
            },
            {
                id: 7,
                name: 'warnings.test.7.name',
                orientation: 'rtl',
                color: 'creme',
                subject: 'warnings.test.7.subject',
                question: 'warnings.test.7.question',
                message: 'warnings.test.7.message',
                image: require('../assets/img/warnings-07.png'),
                answer: null,
                tooltips: {
                    a: 'warnings.test.7.tooltips.a',
                    b: 'warnings.test.7.tooltips.b'
                }
            },
            {
                id: 8,
                name: 'warnings.test.8.name',
                orientation: 'ltr',
                color: 'white',
                subject: 'warnings.test.8.subject',
                question: 'warnings.test.8.question',
                message: 'warnings.test.8.message',
                image: require('../assets/img/warnings-08.png'),
                answer: null,
                tooltips: {
                    a: 'warnings.test.8.tooltips.a',
                    b: 'warnings.test.8.tooltips.b'
                }
            },
            {
                id: 9,
                name: 'warnings.test.9.name',
                orientation: 'rtl',
                color: 'creme',
                subject: 'warnings.test.9.subject',
                question: 'warnings.test.9.question',
                message: 'warnings.test.9.message',
                image: require('../assets/img/warnings-09.png'),
                answer: null,
                tooltips: {
                    a: 'warnings.test.9.tooltips.a',
                    b: 'warnings.test.9.tooltips.b'
                }
            },
            {
                id: 10,
                name: 'warnings.test.10.name',
                orientation: 'ltr',
                color: 'white',
                subject: 'warnings.test.10.subject',
                question: 'warnings.test.10.question',
                message: 'warnings.test.10.message',
                image: require('../assets/img/warnings-10.png'),
                answer: null,
                tooltips: {
                    a: 'warnings.test.10.tooltips.a',
                    b: 'warnings.test.10.tooltips.b'
                }
            },
        ]       
    },
    mutations: {
        scoreYes(state, {question, index}) {
           if (state.warnings[index].answer != 1) {
               state.warnings[index].answer = 1
               state.score++
           } else {
               state.warnings[index].answer = null
               state.score--
           }
        },
        scoreNo(state, {question, index}) {
           if (state.warnings[index].answer == null) {
               state.warnings[index].answer = 0
            } else if (state.warnings[index].answer == 1) {
                state.warnings[index].answer = 0
                state.score--
            } else {
                state.warnings[index].answer = null
            }
        },
        replayTest(state) {
            state.score = 0
            state.warnings.forEach(function(warning){
                warning.answer = null
            })
        }
    },
    actions: {
        
    }
})
